export enum AccessType {
  AUTHORISED = 'AUTHORISED',
  UNAUTHORISED = 'UNAUTHORISED',
  INCORRECT_ADVERTISER = 'INCORRECT_ADVERTISER',
  NOT_FOUND = 'NOT_FOUND',
}
